import { render, staticRenderFns } from "./warehouseEdit.vue?vue&type=template&id=4a8b5856&"
import script from "./warehouseEdit.vue?vue&type=script&lang=js&"
export * from "./warehouseEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports